var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"map",staticClass:"v-map",style:({ height: `${_vm.height}px` })},[(_vm.google && _vm.map)?_c('v-map-popup',{attrs:{"google":_vm.google,"map":_vm.map,"position":_vm.popup && _vm.popup.position}},[(_vm.popup)?_vm._t("popup",null,{"popup":_vm.popup.data}):_vm._e()],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }